import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import type { IUserTransaction } from '@/interfaces';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
	<TableHeader>
		<TableRow>
			<TableHeadSortable className="w-[110px]" name={nameof<IUserTransaction>('createdAt')} text="Date" />
			<TableHeadSortable className="w-[100px]" name={nameof<IUserTransaction>('type')} text="Type" />
			<TableHeadSortable className="w-[140px]" name={nameof<IUserTransaction>('product')} text="Produit" />
			<TableHeadSortable
				className="w-[120px]"
				name={nameof<IUserTransaction>('amount')}
				text="Pièces"
				classNameContent="justify-start"
			/>
			<TableHead className="w-0">Détails</TableHead>
			<TableHead className="w-0">Commentaire</TableHead>
		</TableRow>
	</TableHeader>
);

export default DataTableHeader;
